import { ReactNode, HTMLAttributes } from "react";
import "./field-list-view.scss";
import TooltipTrigger from "../tooltip-trigger";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export interface FieldListItem {
  label: ReactNode | string;
  value: any;
  info?: ReactNode | string;
  oneLiner?: boolean;
  itemClass?: string;
}
interface FieldListDOMProps extends HTMLAttributes<HTMLUListElement> {}
export interface FieldListProps extends FieldListDOMProps {
  fields: { [key: string]: FieldListItem };
  asOneLiners?: boolean;
  inline?: boolean;
  labelClass?: string;
  valueClass?: string;
}

function FieldList(props: FieldListProps) {
  const { fields, inline, labelClass, valueClass, asOneLiners, ...other } =
    props;
  const keys = Object.keys(fields);
  return (
    <>
      {keys.length > 0 && (
        <ul
          className={"list-unstyled field-list" + (inline ? " inline" : "")}
          {...other}
        >
          {keys.map((k) => (
            <li
              key={k}
              className={
                (asOneLiners && fields[k].oneLiner !== false) ||
                fields[k].oneLiner
                  ? "one-liner row " + (fields[k].itemClass || "")
                  : fields[k].itemClass
                  ? fields[k].itemClass
                  : undefined
              }
            >
              <strong
                className={"field-label" + (labelClass ? " " + labelClass : "")}
              >
                {fields[k].label}
                {(asOneLiners && fields[k].oneLiner !== false) ||
                inline ||
                fields[k].oneLiner
                  ? ":"
                  : undefined}
              </strong>
              <span
                className={"field-value" + (valueClass ? " " + valueClass : "")}
              >
                {fields[k].value}
              </span>
              {fields[k].info && (
                <TooltipTrigger tipKey={"field-info"} tip={fields[k].info}>
                  <FontAwesomeIcon
                    icon={"info-circle"}
                    className={"ml-1 text-info"}
                  />
                </TooltipTrigger>
              )}
            </li>
          ))}
        </ul>
      )}
    </>
  );
}

export default FieldList;
